import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import messages from '../../../locale/jsonMessages';
import { GENERAL_STATE_OPTIONS } from '../../../helpers/inspectionForm';
import { ICONS } from '../InspectionStatusBadge/InspectionStatusBadge';
import s from '../Inspection.css';

const STATE_CLASS = { clean: 'stateClean', average: 'stateAverage', dirty: 'stateDirty' };

// Clean / Average / Dirty. Each choice carries an icon and a text, in addition to its colour.
export function GeneralStateSelector({ value, onChange, disabled, name, intl, invalid }) {
  const { formatMessage } = intl;
  if (disabled) {
    const current = GENERAL_STATE_OPTIONS.find((option) => option.value === value);
    if (!current) return <p className={s.readOnlyValue}>-</p>;
    return (
      <div className={cx(s.optionLabel, s.optionLabelSelected, s[STATE_CLASS[current.value]])}>
        <span className={s.optionBody}>
          <span className={s.optionIcon} aria-hidden="true">{ICONS[current.icon]}</span>
          <span><span className={s.optionText}>{formatMessage(messages[current.labelKey])}</span><span className={s.optionHint}>{formatMessage(messages[current.hintKey])}</span></span>
        </span>
      </div>
    );
  }
  return (
    <div role="radiogroup" aria-label={formatMessage(messages.inspGeneralStateTitle)} aria-invalid={invalid ? 'true' : undefined} className={s.optionRow}>
      {GENERAL_STATE_OPTIONS.map((option) => {
        const selected = option.value === value;
        return (
          <label key={option.value} className={cx(s.optionLabel, selected && s.optionLabelSelected, selected && s[STATE_CLASS[option.value]])}>
            <input type="radio" className={s.optionInput} name={name} value={option.value} checked={selected} onChange={() => onChange(option.value)} />
            <span className={s.optionBody}>
              <span className={s.optionIcon} aria-hidden="true">{ICONS[option.icon]}</span>
              <span><span className={s.optionText}>{formatMessage(messages[option.labelKey])}</span><span className={s.optionHint}>{formatMessage(messages[option.hintKey])}</span></span>
            </span>
          </label>
        );
      })}
    </div>
  );
}

GeneralStateSelector.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  invalid: PropTypes.bool,
  name: PropTypes.string
};
GeneralStateSelector.defaultProps = { value: '', onChange: () => {}, disabled: false, name: 'generalState' };

export default injectIntl(withStyles(s)(GeneralStateSelector));
